import React from "react";
import { Col, Row } from "react-bootstrap";
import { ProductReferenceField } from "../../CompoundFields/ProductReferenceField";
import { DescriptionField } from "../../CompoundFields/DescriptionField";
import { ContentLanguageForm } from "../../Parts/ContentLanguageForm";
import { Condition } from "../../Conditionals/Condition";
import { TranslationForm } from "../../Parts/TranslationForm";
import { SpecialForm } from "../../Parts/SpecialForm";
// import { PrintForm } from "../../Parts/PrintForm";

export const Brochure = () => {
    return <Row>
        <hr/>
        <Col md={ 12 }>
            <h2>Brochure</h2>
            <ProductReferenceField
                elementType="brochure"
            />
        </Col>

        <DescriptionField
            parent="Brochure"
        />

        <ContentLanguageForm
            elementType="brochure, catalog, flier, etc."
        />

        <Condition when="Content Language Option" is="Translation">
            <TranslationForm
                elementType="brochure, catalog, flier, etc."
            />
        </Condition>
        <Condition when="Content Language Option" is="Special">
            <SpecialForm/>
        </Condition>

        {/*<PrintForm/>*/}
    </Row>;
}